import type { AxiosResponse } from 'axios'
import type { UploadProgressEvent } from 'element-plus/es/components/upload/src/upload'
import type { OssData, OssToken } from '../types/material'
import type { MsUploadResource } from '../types/ms-upload'
import Axios from 'axios'

export async function fetchUploadToken(path: string): Promise<OssToken> {
  return Axios.get(path).then((res) => {
    const resToken = res.data as OssData
    return {
      path: `${resToken.token.directory}${resToken.key}`,
      policy: resToken.token.policy,
      accessid: resToken.token.access_key_id,
      signature: resToken.token.signature,
      host: resToken.token.host,
    } as OssToken
  })
}

export async function fetchUploadManage(fileName: string, data: OssToken, file: File, onUploadProgress?: (event: UploadProgressEvent) => void): Promise<AxiosResponse<void>> {
  const form = new FormData()
  form.append('key', `${data.path}/${fileName}`)
  form.append('policy', data.policy)
  form.append('OSSAccessKeyId', data.accessid)
  form.append('signature', data.signature)
  form.append('file', file)
  return Axios.post(data.host, form, {
    onUploadProgress,
    timeout: 0,
  })
}

export async function createResource(path: string, params: Partial<MsUploadResource>): Promise<AxiosResponse<{
  id: number
}>> {
  return Axios.post(path, params)
}
